import {
  SGender,
  SBookingNumber,
  SLastName,
  SFirstName,
  SMembershipNumber,
  SFlightNumber,
  SFlightDateRange,
  SOrigin,
  SDestination,
  SEmailAddress,
  SMessage,
  SDateOfBirth,
  SPhoneCode,
  SPhoneNumber,
  SPreferedFareType
} from '@/schemas/forms/Fields.schema'
import { z } from 'zod'

export const SBookingDetails = z.object({}).merge(SBookingNumber).merge(SLastName)
export const SPassengerDetails = z
  .object({})
  .merge(SGender)
  .merge(SFirstName)
  .merge(SLastName)
  .merge(SMembershipNumber)
  .partial()
export const SPassengerDetailsV2 = z
  .object({})
  .merge(SGender)
  .merge(SFirstName)
  .merge(SLastName)
  .merge(SMembershipNumber)
  .merge(SDateOfBirth)
  .merge(SPhoneCode)
  .merge(SPhoneNumber)
  .merge(SEmailAddress)
export const SFlightDetails = z
  .object({})
  .merge(SFlightNumber)
  .merge(SFlightDateRange)
  .merge(SOrigin)
  .merge(SDestination)
  .partial()
export const SFlightDetailsV2 = z
  .object({})
  .merge(SFlightNumber)
  .merge(SFlightDateRange)
  .merge(SOrigin)
  .merge(SDestination)
  .merge(SPreferedFareType)
  .merge(SMessage)
export const SContactsDetails = z.object({}).merge(SMessage).merge(SFirstName).merge(SLastName).merge(SEmailAddress)
